import React from "react";

import TimeAgo from "react-timeago";
import czechStrings from 'react-timeago/lib/language-strings/cs';
import buildFormatter from 'react-timeago/lib/formatters/buildFormatter';

const formatter = buildFormatter(czechStrings);

class CzechTimeAgo extends React.Component {
	render() {
		return (<TimeAgo {...this.props} formatter={formatter} />);
	}
}

export default CzechTimeAgo;


// WEBPACK FOOTER //
// ./src/components/CzechTimeAgo.jsx